import * as types from "../../constants";
import { decryptPatientsData, decryptSinglePatientData } from '../../utils/index.jsx'; 
/**
 * Reducer that saves all the investigations loaded
 * @constructor
 * @param {boolean} state 
 */

 const initialState = {
    data: null,
    loading: false,
    error: null,
    progress: null,
    // True only while the paginated bulk download (fetchPatientsAction, non-silent)
    // is running. Unlike `loading` — which is also set by saves, searches and
    // incremental syncs — this drives the full-viewport blocking overlay in
    // layouts/Dashboard.jsx, so it must never be left dangling: every exit path
    // of the download dispatches PATIENTS_DOWNLOAD_FINISH or FETCH_NEW_PATIENTS_SUCCESS.
    downloading: false,
    // Last patient search (criteria + results) so it survives the SearchPatients
    // component unmounting when the user drills into a patient and navigates back.
    search: null
}
export default function reducer(state = initialState, action){
    let patientsData = null;
    let newState = { ...state};
    let tempInvestigations;
    switch(action.type){
        case types.FETCH_NEW_PATIENTS_SUCCESS:
            tempInvestigations = {...newState.data};
            tempInvestigations[action.investigation.uuid] = action.investigation.patientsPersonalData;
            newState.data = tempInvestigations;
            newState.loading = initialState.loading;
            newState.error = initialState.error;
            newState.progress = initialState.progress;
            newState.downloading = initialState.downloading;
            return newState;
        case types.PATIENTS_DOWNLOAD_START:
            newState.downloading = true;
            return newState;
        case types.PATIENTS_DOWNLOAD_FINISH:
            newState.downloading = false;
            newState.progress = initialState.progress;
            return newState;
        case types.FETCH_PATIENTS_PROGRESS:
            newState.loading = true;
            newState.progress = {
                loaded: action.loaded,
                total: action.total,
                percentage: action.percentage
            };
            return newState;
        case types.UPDATING_PATIENTS_LOADING:
            newState.loading = true;
            newState.error = initialState.error;
            return newState;
        case types.DELETE_PATIENT:
            tempInvestigations = {...newState.data};
            tempInvestigations[action.payload.uuidInvestigation] = tempInvestigations[action.payload.uuidInvestigation].filter(patient => patient.uuid !== action.payload.uuidPatient);
            newState.data = tempInvestigations;
            return newState; 
        case types.FETCH_INVESTIGATIONS_SUCCESS:
            //Desencripto los datos de los pacientes
            // tempInvestigations = {};
            // for(const investigation of action.investigations){
            //     tempInvestigations[investigation.uuid] = investigation.patientsPersonalData;
            // }

            // newState.data = tempInvestigations;                            
            // return newState;
            return state;
        case types.SAVE_PATIENT_LOADING:
            newState.loading = true;
            newState.error = initialState.error;
            return newState;
        case types.SAVE_PATIENT_ERROR:
            newState.loading = initialState.loading;
            newState.error = action.error || true;
            return newState;
        case types.SUBMISSIONS_PATIENT_RESET_ERROR:
            newState.error = initialState.error;
            return newState;
        case types.UPDATE_PATIENT_OFFLINE:
        case types.UPDATE_PATIENT_SUCCESS:    
        case types.SAVE_PATIENT_OFFLINE:
        case types.SAVE_PATIENT_SUCCESS:
            tempInvestigations = {...newState.data};
            tempInvestigations[action.investigation.uuid] = action.investigation.patientsPersonalData;
            newState.data = tempInvestigations;
            newState.loading = initialState.loading;
            newState.error = initialState.error; 
           
            return newState;
            case types.INITIALIZE_PATIENTS:
                newState.data = {};
                newState.data[action.payload.uuidInvestigation] = action.payload.patients
                
                return newState;
            case types.UPDATE_PATIENT_STATUS: {
                const updatedPatient = action.patient;
                const statusPatientUuid = action.uuidPatient;
                if (newState.data) {
                    const newData = {...newState.data};
                    for (const uuidInv of Object.keys(newData)) {
                        const patients = newData[uuidInv];
                        if (patients && Array.isArray(patients)) {
                            const idx = patients.findIndex(p => p.uuid === statusPatientUuid);
                            if (idx !== -1) {
                                newData[uuidInv] = patients.map(p =>
                                    p.uuid === statusPatientUuid
                                        ? { ...p, status: updatedPatient.status, dateOfDeath: updatedPatient.dateOfDeath }
                                        : p
                                );
                                break;
                            }
                        }
                    }
                    newState.data = newData;
                }
                return newState;
            }
            case types.AUTH_SIGN_OUT:
                newState = {...initialState};
                return newState;
            case types.SET_PATIENT_SEARCH:
                newState.search = action.search;
                return newState;
            case types.CLEAR_PATIENT_SEARCH:
                newState.search = initialState.search;
                return newState;
            case types.SELECT_INVESTIGATION:
                // Switching investigation invalidates a search scoped to the previous one.
                newState.search = initialState.search;
                return newState;
            case types.UPDATE_PATIENT_INSURANCE_SUCCESS: {
                const { uuidInvestigation, uuidPatient, newInsuranceId } = action;
                if (newState.data && newState.data[uuidInvestigation]) {
                    newState.data[uuidInvestigation] = newState.data[uuidInvestigation].map(patient =>
                        patient.uuid === uuidPatient
                            ? { ...patient, personalData: { ...patient.personalData, coverage: newInsuranceId } }
                            : patient
                    );
                }
                return newState;
            }
            default:
                return state;
    }
}